import { get, post } from "utilities/network";
export interface WithdrawalReview {
  id: number;
  userID: number;
  status: string;
  reason: string | null;
  livenessStatus: string;
  complianceStatus: string;
  rejectionReason: string | null;
  createdAt: string;
}
export interface ReviewTransaction {
  id: number;
  amount: string;
  currency?: string | null;
  currencyType?: string;
  status: string;
}
export interface ReviewDetail {
  review: WithdrawalReview;
  transactions: ReviewTransaction[];
  otcTransactions: ReviewTransaction[];
  auditLogs: {
    id: number;
    actionType: string;
    reason: string | null;
    timestamp: string;
  }[];
}
export interface WithdrawalRule {
  id: number;
  source: string | null;
  currency: string | null;
  triggerType: string;
  thresholdAmount: string | null;
  enabled: boolean;
}
export interface RuleChange {
  id: number;
  ruleID: number;
  requestedChange: { enabled?: boolean; thresholdAmount?: number };
  status: string;
  requestedBy: number;
  requestReason: string;
  approvalReason: string | null;
  createdAt: string;
}
export type ReviewAction = "clear-flag" | "escalate" | "reverse";
const root = "admin/transactions";
export const withdrawalReviewsApi = {
  list: (
    status: string,
    page: number,
  ): Promise<{ reviews: WithdrawalReview[]; total: number }> =>
    get(
      `${root}/withdrawal-reviews?status=${encodeURIComponent(status)}&page=${page}&limit=25`,
    ),
  detail: (id: number): Promise<ReviewDetail> =>
    get(`${root}/withdrawal-reviews/${id}`),
  act: async (
    id: number,
    action: ReviewAction,
    reason: string,
  ): Promise<{ review: WithdrawalReview }> =>
    (await post(`${root}/withdrawal-reviews/${id}/${action}`, { reason })).data,
  rules: (): Promise<{ rules: WithdrawalRule[] }> =>
    get(`${root}/withdrawal-review-rules`),
  changes: (status: string): Promise<{ changeRequests: RuleChange[] }> =>
    get(
      `${root}/withdrawal-review-rules/change-requests?status=${encodeURIComponent(status)}`,
    ),
  requestChange: (
    id: number,
    input: { enabled: boolean; thresholdAmount?: number; reason: string },
  ) => post(`${root}/withdrawal-review-rules/${id}/change-requests`, input),
  decideChange: (id: number, decision: "approve" | "reject", reason: string) =>
    post(`${root}/withdrawal-review-rules/change-requests/${id}/${decision}`, {
      reason,
    }),
};
